export default __webpack_public_path__ + "static/media/email.d33b641d.svg";